import type { ShipmentProgress } from '@lib/types/order'

// TODO: make shipmentProgress required after subscription orders implementation
type Props = {
	shipmentProgress?: ShipmentProgress
}

// *** shipmentProgress ***
// null - Order hasn't shipped
// 0 - Order shipped / FULFILLED
// 1 - Out for delivery / IN_PROGRESS
// 2 - In progress / IN_TRANSIT
// 3 - Delivered / DELIVERED
const position: Record<Exclude<ShipmentProgress, null>, string> = {
	0: '0%',
	1: '33.33333%',
	2: '66.666667%',
	3: '100%'
}

const trackLengthArray = Array.from({ length: Object.keys(position).length }, (_, i) => i)

export default function ShipmentTracker({ shipmentProgress }: Props) {
	const trackerPosition = position[shipmentProgress as keyof typeof position] ?? position[0]

	return (
		<div className="relative w-full">
			{/* Track */}
			<div className="relative flex items-center justify-between w-full h-1 bg-gray-100 rounded-full">
				{trackLengthArray.map((i) => (
					<div
						key={`shipment-progress-${i}`}
						className={`w-3 h-3 rounded-full ${
							shipmentProgress && shipmentProgress >= i ? 'bg-bbx-spark' : 'bg-gray-100'
						}`}
					/>
				))}

				{/* Colored track */}
				<div
					className="absolute inset-x-0 top-0 w-full h-full transition-transform duration-[800ms] ease-in-out origin-left bg-bbx-spark"
					style={{ transform: `scaleX(${trackerPosition})` }}
				/>
			</div>

			{/* Circles surrounding icon */}
			<div
				className={`absolute inset-0 trasnition duration-[800ms] ease-in-out ${
					typeof shipmentProgress !== 'number' ? 'hidden' : ''
				}`}
				aria-hidden="true"
				style={{ transform: `translate(${trackerPosition}, 0)` }}
			>
				<div className="relative rounded-full bg-bbx-spark p-1.5 before:bg-bbx-spark/50 before:absolute before:-inset-2 before:rounded-full w-min -translate-y-1/2 -translate-x-1/2">
					{/* Truck icon */}
					<svg
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="relative z-10"
					>
						<path
							d="M8.25 3.75001H10.2469C10.3216 3.74952 10.3947 3.77165 10.4566 3.81348C10.5185 3.85531 10.5663 3.91488 10.5938 3.98438L11.25 5.62501"
							stroke="white"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path d="M0.75 6.75H8.25" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
						<path
							d="M8.8125 10.125C9.43382 10.125 9.9375 9.62132 9.9375 9C9.9375 8.37868 9.43382 7.875 8.8125 7.875C8.19118 7.875 7.6875 8.37868 7.6875 9C7.6875 9.62132 8.19118 10.125 8.8125 10.125Z"
							stroke="white"
							strokeMiterlimit="10"
						/>
						<path
							d="M3.1875 10.125C3.80882 10.125 4.3125 9.62132 4.3125 9C4.3125 8.37868 3.80882 7.875 3.1875 7.875C2.56618 7.875 2.0625 8.37868 2.0625 9C2.0625 9.62132 2.56618 10.125 3.1875 10.125Z"
							stroke="white"
							strokeMiterlimit="10"
						/>
						<path
							d="M7.6875 9H4.3125"
							stroke="white"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M2.0625 9H1.125C1.02554 9 0.930161 8.96049 0.859835 8.89017C0.789509 8.81984 0.75 8.72446 0.75 8.625V3.375C0.75 3.27554 0.789509 3.18016 0.859835 3.10984C0.930161 3.03951 1.02554 3 1.125 3H8.25V8.025"
							stroke="white"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M8.25 5.625H11.25V8.625C11.25 8.72446 11.2105 8.81984 11.1402 8.89017C11.0698 8.96049 10.9745 9 10.875 9H9.9375"
							stroke="white"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
			</div>
		</div>
	)
}
